<template>
  <v-footer class="flex-column elevation-18" style="padding: 25px;">

<!--    <v-btn dark icon fab fixed bottom left-->
<!--           style="background-color: rgba(50,50,200,0.5)"-->
<!--           v-scroll="onScroll"-->
<!--           @click="$vuetify.goTo(0)" v-show="fab">-->
<!--      <v-icon>-->
<!--        mdi-chevron-up-->
<!--      </v-icon>-->
<!--    </v-btn>-->

    <v-row>
      <v-col>

        <b>Ønsker du å vite mer?</b>
<!--        <v-btn block rounded depressed @click="toTop">-->
<!--          -->
<!--          <v-icon>-->
<!--            mdi-chevron-up-->
<!--          </v-icon>-->
<!--          Til top-->
<!--          <v-icon>-->
<!--            mdi-chevron-up-->
<!--          </v-icon>-->

<!--        </v-btn>-->
      </v-col>
    </v-row>

    <v-row>

      <v-col cols="12" md="6" class="text-center">
        <b>Tjenester</b>
        <v-divider></v-divider>

        <v-btn style="margin: 1em"  rounded text to="/bms">Intelligente bygg</v-btn>
<!--        <v-btn style="margin: 1em"  rounded text to="/systems">Digital kjørebok</v-btn>-->
<!--        <v-btn style="margin: 1em"  rounded text to="/sensors">Sensorer</v-btn>-->
<!--        <v-btn style="margin: 1em"  rounded text to="/development">Utvikling</v-btn>-->
        <v-btn style="margin: 1em"  rounded text to="/about">Om oss</v-btn>
        <v-btn style="margin: 1em"  rounded text to="/faq">Ofte stilte spørsmål</v-btn>

      </v-col>
      <v-col cols="12" md="6" class="text-center">
        <b>Kontakt</b>
        <v-divider></v-divider>

        <v-btn style="margin: 1em"  rounded text class="noclick">Adresse: Trosteveien 26</v-btn>
        <v-btn style="margin: 1em"  rounded text class="noclick">Telefon: +47 90 96 29 99</v-btn>
        <v-btn style="margin: 1em"  rounded text class="noclick">Epost:
          <a href="mailto:contact@sitesense.no?subject=Jeg%20ønsker%20å%20vite%20mer">
            contact@sitesense.no
          </a>
        </v-btn>
<!--        <p>Ekornsvingen 9</p>-->
<!--        <p>Telefon: +47 91 74 25 53</p>-->
<!--        <p>Epost:-->
<!--          contact@sitesense.no-->
<!--          <a href="mailto:contact@sitesense.no?subject=Jeg%20ønsker%20å%20vite%20mer">-->
<!--            contact@sitesense.no-->
<!--          </a>-->
<!--        </p>-->


      </v-col>

    </v-row>

    <v-row class="pa-5">
      <v-col cols="12" md="6" class="d-flex justify-center align-center">
          <img src="../assets/sitesense_logo.png" height="69"/>
      </v-col>
      <!--v-col cols="12" md="6" class="d-flex justify-center align-center">
          <img src="../assets/logo-power-solutions.png" height="69"/>
      </v-col-->
    </v-row>
    <v-row>
      <v-col>
        <p>
          ©2023 SiteSense AS   |   Smarte bygg, sensor- og automasjonsløsninger
        </p>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  name: "FooterBar",
  data: () => ({
    fab: false,
    name: undefined,
    email: undefined,
  }),
  methods: {
    onScroll (e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset ||   e.target.scrollTop || 0
      this.fab = top > 20
    },
    onEmailSend() {
      console.log('I WOULD LIKE TO KNOW MORE')
      console.log(this.email)
    },
    toTop () {
      this.$vuetify.goTo(0)
    },
  },
  computed: {

    target () {
      return 'app'
    },
    options () {
      return {
        duration: this.duration,
        offset: this.offset,
        easing: this.easing,
      }
    },
  }
}
</script>

<style scoped>
.noclick {
  cursor: default;
}
</style>
